// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbeETdAdjB9rnM1JOtB9cvgHwMLdCxBl8",
  authDomain: "true-crime-police-server.firebaseapp.com",
  projectId: "true-crime-police-server",
  storageBucket: "true-crime-police-server.firebasestorage.app",
  messagingSenderId: "639618234555",
  appId: "1:639618234555:web:9c397a8c8543d98739d19e",
  measurementId: "G-EJFGD1TZSY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');
